import React from "react"

export function Magic(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* wand shaft */}
      <path d="M4 20L15 9" />
      {/* wand tip star */}
      <path d="M17 5l1 2 2 1-2 1-1 2-1-2-2-1 2-1z" />
      {/* two small sparkles */}
      <path d="M19.5 13.5v3M18 15h3" />
      <path d="M6 4v2.5M4.75 5.25h2.5" />
    </svg>
  )
}
